module.exports = __webpack_public_path__ + "img/IMG_0079_L_BlackMatted_MockedUp.30e67d6e.jpg";